import {
  appBgColor,
  boxShadow, min, primaryColor, primaryFont,
  secondaryFont, wMBold, wLight,
  wMedium, primaryHeadingColor, wELight, minWidthApp, maxTablet, maxMobile,
  backDropPersonality, wbSmartLayer, wBold,
  joinSession, scrollbar, maxWidth1300,
  textTruncateSnippet, retina, retinaOne,
  scrollbarTransparent, smMobile, midMobile,
  primaryBgColor, backgroundGreenLayer,
  SecondaryColor, midTablet, white,
  minExtraLargeScreen, minStandardScreen,
  greyColor,
  wMLight,
  minTablet,
  midWidthApp,
  maxWidth1170,
  maxWidth,
} from '../../Utils/utilsStyle';

const generalStylePeople = `
    z-index: 5; 
    .search-wrapper {
      .cross-icon {
        width: 14px;
        height: 14px;
        top: 8px;
        right: 15px;
        cursor: pointer;
      }
      .search-field-icon{
        display: flex;
        top: 11;
        justify-content: center;
        align-items: center;



      }
    }
    .ant-input-affix-wrapper {
      padding: 5px 11px;
      >input.ant-input {
        padding-right: 10px;
        min-height: 18px;
        padding-bottom: 0px;
        line-height: 26px;
        ::placeholder {
          color: #757575;
          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          letter-spacing: -0.4px;
        }
      }
    }
    .buyer-skeleton-wrapper {
      margin-bottom: 16px;
    }
  }
  .drawer-account-cluster {
    &.ant-drawer {
      z-index: 10;
      .ant-drawer-content {
        .ant-drawer-header {   
          border-bottom: none; 
          .ant-drawer-close {
            display: none;
          }
        }
        .ant-drawer-body {
          padding: 0px;
          display: flex;
          flex-direction: column;
          height: 100%;
          overflow: hidden;
        }
      }
    }
  }
  .sales-sigma-leadership-drawer {
    .ant-drawer-body {
      display: flex;
      flex-direction: column;
      padding: 0 40px !important;
      ${scrollbar};
      overflow: auto !important;
      @media all and (max-width: ${maxMobile}) {
        padding: 0 10px;
      }
    }
  }
  .welcome-tour-popup{
    .ant-modal-close,.ant-modal-footer {
      display: none;
    }
    .ant-modal-content  {
      .ant-modal-body {
        padding: 0px;
        padding-top: 0px;
      }
    }
   
  }
  .welcome-tour-popup{
    .ant-modal-close,.ant-modal-footer {
      display: none;
    }
    .ant-modal-content  {
      .ant-modal-body {
        padding: 0px;
        padding-top: 0px;
      }
    }
   
  }
  .ant-input-textarea {
    .ant-input {
    background: #FBFBFB;
    border: 1px solid #E4E4E4;
    border-radius: 5px;  
    }
    &.ant-input-textarea-show-count {
      &:after {
      bottom: 5px;
      position: absolute;
      right: 12px;
      font-size: 11px;
      font-family: 'Roboto';
      font-style: italic;
      }
    }
  }
  .ant-input-textarea, .ant-input-affix-wrapper-textarea-with-clear-btn {
    position: relative;
    .ant-input {
      padding: 32px 26px 32px 16px;
      font-style: italic;
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      color: #979797;
      font-family: ${primaryFont};
      resize: none;
      &:focus, &:hover {
		    border-color: ${primaryColor};
        box-shadow: 0 0 0 1px ${primaryColor};
	    }
      &.text-area-reason {
        padding: 16px 23px 16px 12px;
        font-weight: ${wLight};
        font-size: 11.8033px;
        line-height: 16px;
        color: #67696A;
        font-style: normal;
        border-radius: 4px !important; // by reason important
      }
    }
  }
  .filter-placeholder {
    &.serviceLines {
      .ant-popover-content {
        @media all and (max-width: ${maxWidth}) , ${retina} {
          width: 335px !important;
        }
        .grid-checkbox-wrapper {
          max-height: 310px;
          ${scrollbar};
        }
      }
    }
  }
  .ant-picker-dropdown {
    @media all and (max-width: ${maxMobile}) {
      zoom: 0.7;
    }
    @media all and (max-width: ${smMobile}) {
      zoom: 0.5;
    }
    .ant-picker-cell-selected, .ant-picker-cell-range-start, .ant-picker-cell-range-end {
      .ant-picker-cell-inner {
        background: #1EC252 !important;
        color: #fff !important;
        &:hover {
          background: #1EC252 !important;
          color: #fff !important;
        }
      }
    }
    .ant-picker-cell-in-range {
      &::before {
        background: rgb(222, 246, 230) !important; 
      }
    }
    .ant-picker-cell-in-view {
      .ant-picker-cell-today {
        .ant-picker-cell-inner {
          &::before {
            border: 1px solid #1EC252 !important;
          }
        }
      }
    }
  }
  
  &.reason-drawer {
    z-index: 5;
    .ant-drawer-header {
      padding: 16px 24px 0px 24px;
    }
    .ant-drawer-body {
      overflow: hidden;
      padding: 0px;
      .unique-reason-class {
        .infinite-scroll-component__outerdiv {
          height: 100%;
        }
      }
      .data-append-wrapper {
        padding-bottom: 50px;
        height: calc(100% - 150px) !important;
        @media all and (max-width: ${maxWidth}) , ${retina} {
         height: calc(100% - 110px) !important;
        }
        ${scrollbar};
      }
    }
    .reason-drawer-close {
      position: absolute;
      right: 20px;
    }
    .add-note{
      display: flex;
      align-items: center;
      cursor: pointer;
      height: 50px;
      padding: 15px 35px 15px 30px;
      margin-top: 10px;
      @media all and (max-width: ${minWidthApp}) {
        display: none;
      }
      .add-note-input {
        width: 100%;
        margin-left: 12px;
        font-style: italic;
        padding: 5px 10px 5px 20px;
        border-radius: 5px;
        border: 1px solid #E4E4E4;
        font-family: ${primaryFont};
        font-size: 13px;
        line-height: 18px;
        font-weight: ${wLight};
        color: #E4E4E4;
      }
    }
    .person-dropdown {
      @media all and (max-width: ${smMobile}) {
        max-height: 165px;
      }
      .image {
        .person-without-holo {
          @media all and (max-width: ${smMobile}) {
              width: 25px;
              height: 25px;
              min-width: 25px;
              padding: 1px !important;
          }
        }
      }
      .content {
        @media all and (max-width: ${smMobile}) {
          .name, .designation, .company {
            font-size: 10px;
          }
        }
      }
    }
  }
  .layout-controller {
    margin-left: 10px;
    .tabs-item {
      &.disable {
        background-color: rgb(249, 248, 246);
        opacity: 0.7;
      }
        padding: 0px 10px;
        height: 30px;
        @media all and (max-width: ${maxTablet}) {
         height: 25px; 
        }
        &:nth-child(1){
          margin-right: 0px;
          border-radius: 8px 0px 0px 8px !important;
        }
        &:nth-child(2){
          border-radius: 0px 8px 8px 0px !important;
        }
    }
    svg {
      width: 22px;
      min-width: 22px;
      height: 27px;
      @media all and (max-width: ${maxTablet}) {
        height: 23px;
        width: 18px;
        min-width: 18px;
      }
    }
  }
  .resolution-fix {
    .skeleton-box {
      margin-right: 10px;
    }
    &.top-people {
      .skeleton-box {
        @media all and (max-width: ${minWidthApp}) {
         width: 65px;
        min-width: 65px;
        height: 65px !important;
        }
      }
    }
    &.top-companies {
      .skeleton-box {
        @media all and (max-width: ${minWidthApp}) {
          width: 110px;
          min-width: 110px;
          height: 70px !important;
        }
      }
    }
    &.engagement-trigger-fix {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}) { 
          min-width: 160px;
          width: 160px;
          height: 38px !important;
        }
      }
    }
    &.engagement-text {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){ 
          min-width: 100px;
          width: 100px;
          height: 20px !important;
        }
      }
    }
    &.workbenchStats-company {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){ 
          min-width: 100px;
          width: 100px;
          height: 90px !important;
        }
      }
    }
    &.navbarFix {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){ 
          min-width: 400px;
          width: 400px;
          height: 28px !important;
        }
      }
    }
    &.digest-skelton-fix {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){ 
          min-width: 180px;
          width: 180px;
          height: 150px !important;
        }
      }
    }
    &.pulse-fix {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){ 
          width: 570px;
          min-width: 570px;
          height: 22px !important;
        }
        @media all and (max-width: ${minWidthApp}) {
          width: 530px;
          min-width: 530px;
          height: 18px !important;
        }
         @media all and (max-width: ${maxTablet}) {
          width: 100%;
          min-width: 100%;
          height: 18px !important;
        }
      }
    }
    &.pulse-sales-trigger {
      .skeleton-box {
        @media all and (max-width: ${minWidthApp}) {
          width: 80px;
          min-width: 80px;
          height: 18px !important;
        }
      }
    }
    &.pulse-board-tabs {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){ 
          width: 70px;
          min-width: 70px;
          height: 35px !important;
        }
        @media all and (max-width: ${minWidthApp}) {
          width: 50px;
          min-width: 50px;
          height: 30px !important;
        }
      }
    }
    &.for-comapny {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){ 
          width: 110px;
          min-width: 110px;
        }
      }
    }
    &.for-people {
      .skeleton-box {
        @media all and (max-width: ${maxWidth1300}){
          width: 70px;
          min-width: 70px;
          height: 70px !important;
        }
      }
    }
    &.global-button-fix {
      @media all and (max-width: ${minWidthApp}) {
        .resultRow {
          .button-column {
            button {
              width: 540px;
              display: inline-block !important;
              @media all and (max-width: ${maxTablet}) {
                width: 90%;
              }
            }
          }
        }
      }
    }
  }
  .tabs-wrapper {
    &.resolution-filter-popover {
      @media all and (max-width: ${minWidthApp}) {
        margin: 0px 0px 0px 10px;
      }
      @media all and (max-width: ${maxTablet}) {
        margin: 0px 0px 0px 10px;
      }
      .tabs-item {
        gap: 0px;
          @media all and (max-width: ${maxTablet}){
            background-color: #fff;
            border: 1px solid #DADADA;
            margin-left: 0px;
            width: 30px;
            height: 24px;
            padding-left: 3px;
            padding-top: 2px;
            svg {
              min-width: 14px;
            }
          }
        }
    }
  }

  .fc-widget-open{
    .content-popover-c {
      display: none;
    }
  }
  
  .ant-scrolling-effect, .body-drawer-toggle {
    .freshDesk-Bot, .fc-widget-small, .fc_push_frame, #onesignal-bell-container, .freshDeskHandle, .content-popover-c {
      display: none;
    }
    .container-heading-div {
      z-index: 5 !important;
    }
  }
  .ant-scrolling-effect, .body-drawer-alerts-toggle {
    .freshDesk-Bot, .fc-widget-small, .fc_push_frame, #onesignal-bell-container, .freshDeskHandle, .content-popover-c {
      display: none;
    }
    .container-heading-div {
      z-index: 5 !important;
    }
  }
  .ant-scrolling-effect, .body-drawer-toggle-account-plan {
    .freshDesk-Bot, .fc-widget-small, .fc_push_frame, #onesignal-bell-container, .freshDeskHandle, .content-popover-c {
      display: none;
    }
    .chatbot-container {
      position: relative;
      z-index: 1;
    }
    .container-heading-div {
      z-index: 5 !important;
    }
  }
  .ant-scrolling-effect, .body-document-accordion {
    overflow-y: auto;
    width: 100%;
    .ant-layout {
      .ant-layout-sider {
        z-index: 4;
      }
      .content-popover-c {
        z-index: 2;
      }
    }
    .container {
      .sub-container-document-hub {
        padding-bottom: 90px;
      }
    }
  }
  .ant-scrolling-effect, .body-drawer-toggle-certification {
    .freshDesk-Bot, .fc-widget-small, .fc_push_frame, #onesignal-bell-container, .freshDeskHandle, .content-popover-c {
      display: none;
    }
    .container-heading-div {
      z-index: 5 !important;
    }
  }  

  .scroll-area-for-drawer {
    margin:-15px 13px 0 30px !important;
    padding-right: 0px;
    height: calc(100vh - 245px) !important;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin: 10px 17px 0 25px;
      height: calc(100vh - 230px) !important;
    }
    @media all and (max-width: ${maxTablet}) {
      margin: 20px 10px 0 10px !important;
    }
    ${scrollbar};
    &.infinite-scroll-component  {
      padding: 10px;
    }
    &.no-people {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }


  .infinite-scroll-group-browse {
    .ant-spin-nested-loading {
      .ant-spin {
        .ant-spin-text {
          color: ${primaryColor};
          font-family: ${primaryFont};
          font-size: 14px;
          font-weight: ${wMedium};
          line-height: normal;
          padding-top: 8px;
        }
      }
    }
    margin:0 17px 0 30px;
    padding-right: 10px;
    height: calc(100vh - 300px) !important;
    ${scrollbar};
    @media all and (max-width: ${maxWidth}), ${retina} {
      margin: 0 17px 0 30px;
      height: calc(100vh - 250px) !important;
    }
    @media all and (max-width: ${maxMobile}) {
      height: calc(100vh - 200px) !important;
      margin: 0 10px;
    }
    &.mergeFooter {
       height: calc(100vh - 260px) !important;
        @media all and (max-width: ${maxWidth}), ${retina} {
          margin: 0 17px 0 30px;
          height: calc(100vh - 240px) !important;
        }
        @media all and (max-width: ${maxMobile}) {
          height: calc(100vh - 235px) !important;
        }
      }
    &.shareFooter {
      height: calc(100vh - 355px) !important;
      @media all and (max-width: ${maxWidth}), ${retina} {
        margin: 0 17px 0 30px;
        height: calc(100vh - 335px) !important;
      }  
    }
    &.footerUnable {
      @media all and (max-width: ${maxTablet}) {
        height: calc(100vh - 365px) !important;
      }
      @media all and (max-width: ${maxMobile}) {
        height: calc(100vh - 280px) !important;
      }
    }
    &.noGroups {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }

  .placement-logic {
    .fancyBox {
      background: transparent;
    }
  }
  .detailPage {
    height: unset !important;
  }
  .noWayToClose{
    .way-no-close {
      .ant-modal-close, .ant-modal-footer {
        display: none !important;
      }
      .ant-modal-body {
        padding: 0px !important;
      }
      .ant-modal-body-custom {
        padding: 50px 0px 70px 0px !important;
        .text_logout_popup {
          margin-bottom: 0px;
          font-size: 16px;
        }
        .mail_link {
          font-size: 16px;
        }
        .email-trigger-btn {
          border-radius: 25px;
          font-size: 16px;
          font-weight: ${wMBold};
          font-family: ${primaryFont};
          width: 115px;
          text-align: center;
          height: auto;
          display: block;
          margin: 15px auto 0px auto;
          padding: 0px 15px !important;
          background-color: ${primaryColor};
          border-color: ${primaryColor};
          color: #fff;
        }
      }
    }
  }

  .target-here-modal {
    .ant-modal-mask, .ant-modal-wrap {
      left: 85px;
    }
  }

  .welcome-tour-popup {
    .ant-modal-close,.ant-modal-footer {
      display: none;
    }
    .ant-modal-content  {
      .ant-modal-body {
        padding: 0px;
        padding-top: 0px;
      }
    }
   
  }

  .certification-completion-popup {
    z-index: 1999;
    .ant-modal-footer {
      display: none;
    }
    .ant-modal-content  {
      .ant-modal-body {
        padding: 57px 20px 55px 20px;
        text-align: center;
        .input {
          width: 50%;
          font-family: ${secondaryFont};
          font-size: 12px;
          border: none;
          border-bottom: 1px solid ${primaryColor};
          padding: 0px 55px 5px 5px;
        }
        .certification-title {
          font-family: ${secondaryFont};
          font-weight: ${wMBold};
          font-size: 32px;
          line-height: 40px;
          letter-spacing: -0.8px;
          color: #424B50;
          margin-top: 10px;
        }
        .certification-description {
          &.name {
            font-size: 12px;
            line-height: 15px;
            margin: 0px;
            font-weight: ${wMedium};
            &.edit {
              color: ${primaryColor};
              margin-left: 3px;
              border-bottom: 1px solid ${primaryColor};
              cursor: pointer;
            }
          }
          &.task-desc {
            font-weight: ${wMedium};
            font-size: 16px;
            line-height: 20px;
            font-family: ${primaryFont};
            margin-bottom: 5px;
          }
          font-family: ${secondaryFont};
          font-weight: ${wMBold};
          font-size: 18px;
          line-height: 15px;
          letter-spacing: -0.36px;
          color: #979797;
          margin: 0px;
        }
        .certification-earned-points {
          font-family: ${secondaryFont};
          font-weight: ${wMedium};
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.36px;
          color: #424B50;
          margin-bottom: 22px;
          margin-top: 30px;
          &.showPoints {
            margin-top: 0px;
            margin-bottom: 40px;
          }
          &.show-text {
            color: #7E7E7E;  
            margin-bottom: 0px;
            margin-top: 0px;
          }
        }
        .certification-checkbox-div {
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 12px;
          .ant-checkbox-wrapper {
            width: 20px;
            margin-bottom: 0px;
            .ant-checkbox {
              .ant-checkbox-inner {
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }
   
  }

  .certification-collapse {
    &.main-collapse > {
      .ant-collapse-item {
         padding: 0px 20px;
        &.ant-collapse-item-active {
          padding: 5px 20px 5px 20px;
          ~ {
            .ant-collapse-item {
              .ant-collapse-header {
                border-top: none;
                border-bottom: 1px solid #DADADA;
              }
              &:last-child {
                .ant-collapse-header {
                  border-bottom: none;
                }
              }
            }
          }
        }
      }
      .ant-collapse-header {
        padding: 10px 20px 10px 30px;
      }
    }
    &.sub-collapse {
      &.certificationSubCollapse {
        .footer-sub-collapse {
          margin-left: 14px;
        }
      }
      margin-top: 0px;
      padding: 0px 0px 0px 12px;
      .ant-collapse-content {
        >.ant-collapse-content-box {
          padding: 0px;
        }
        svg {
          margin-right: 0px;
        }
      }
      .ant-collapse-item-active {
        padding: 0px;
        .ant-collapse-header {
          border-bottom: none;
          padding: 10px 0px 0px 0px;
          .ant-collapse-header-text {
            color:#424B50 !important;
          }
        }
        .ant-collapse-content-active {
          border-bottom: 1px solid #DADADA;
          padding-bottom: 16px;
        }
      }
      .ant-collapse-item {
        .ant-collapse-header {
          .ant-collapse-header-text {
            color:#67696A;
            margin-inline-end: unset !important;
          }
        }
        &:last-child {
          .ant-collapse-header {
            border-bottom: none;
          }
          .ant-collapse-content-active {
            border-bottom: none;
            padding-bottom: 10px;
          }
        }
        .ant-collapse-content-box {
          padding: 0px 0px 10px 0px;
        }
        .ant-collapse-expand-icon {
          margin: 0px -10px 0px 0px;
          svg {
            fill:#979797;
            min-width: 8px;
            width: 8px;
          }
        }
      }
    }
    padding: 10px 20px;
    .ant-collapse-content {
        >.ant-collapse-content-box {
          padding: 0px;
          padding-top: 0px !important;
          padding-bottom: 0px !important;
        }
      }
    .ant-collapse-item-active {
      background: #F7F7F7; 
      border: 1px solid #F7F7F7;
      border-radius: 8px !important;
      .ant-collapse-header {
        border-bottom: 1px solid #DADADA;
        border-top: none !important;
      }
      }
    .ant-collapse-item {
      &:nth-child(1) {
        .ant-collapse-header {
          border-top: none;
        }
      }
      .ant-collapse-header {
        display: flex;
        flex-direction: row-reverse;
        padding: 10px 0px;
        border-top: 1px solid #DADADA;
        transition: auto;
        .ant-collapse-header-text {
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 14px;
          line-height: 20px;
          color: #424B50;
          letter-spacing: -0.36px;
          &.header-text-gray {
            font-weight: ${wLight};
            font-size: 12px;
            color: #67696A;
            margin-top: 3px;
            svg {
              fill: #67696A;
              width: 10px;
              height: 10px;
            }
          }
        }
      }
      .ant-collapse-expand-icon {
          margin: 10px -10px 0px 0px;
        svg {
          fill:#979797;
          min-width: 12px;
        }
      }
    }       
  }

  .certification-collapse-bottom {
    box-shadow: 0px 0px 24px rgb(0 0 0 / 50%); //please dont use variable on it
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: 80%;
    display: flex;
    align-self: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    z-index: 6;
    &.certification-collapse-width {
      width: 50%;
      left: 50%;
      transform: translateX(-68%);
      @media all and (max-width: ${maxWidth}), ${retina} {
       left: 50%;
       transform: translateX(-77%);
      }  
    }
    .cross-circle-accordion {
      cursor: pointer;
      position: absolute;
      right: -15px;
      top: -15px;
      svg {
        height: 15px;
        width: 15px;
        circle {
          fill:#C9C9C9;
        }
        path {
          stroke: #838383;
        }
      } 
    }
     .ant-collapse-item-active {
        .ant-collapse-header {
          border: none;
          padding: 7px 10px 0px 10px;
          .ant-collapse-header-text {
            .accordion-header {
              margin-left: 12px;
              .header-image {
                position: absolute;
                height: 43px !important;
                width: 48px !important;
                padding: 10px;
                border-radius: 12px;
                top: -5px;
                left: 6px;
                background-color: #fff;
              }
            }
          }
          .ant-collapse-header-text { 
            padding: 0 0 0 40px;
          }
        }
        .ant-collapse-expand-icon {
          margin: 0px -10px 0px 0px !important;
        }
      }
     .ant-collapse-item {
        width: 100%;
      .ant-collapse-content-box {
        padding: 0px 10px 10px 10px;
        .sub-component-div {
          display: flex;
          flex-direction: column;
          padding:0 0 0 50px;
          .panel-sub-component {
            display: flex;
            justify-content: space-between;
            font-family: ${primaryFont};
            font-weight: ${wMedium};
            font-size: 14px;
            line-height: 20px;
            color: #67696A;
            margin-bottom: 10px;
            .index{
              color: #67696A;
            }
          }
          .prompt-copy-cert-cmp {
            width: calc(100% - 118px);
            margin-left: 15px;
            margin-bottom: 16px;
          }
        }
      }
      .ant-collapse-header {
        display: flex;
        flex-direction: row-reverse;
        padding: 10px;
        .ant-collapse-header-text {
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 14px;
          line-height: 20px;
          color: #424B50;
          letter-spacing: -0.36px;
          .accordion-header {
            display: flex;
            align-items: center;
            margin-right: 10px;
            justify-content: space-between;
            .header-image {
              width: 34px;
              height: 28px;
              margin-right: 10px;
            }
          }
        }
      }
      .ant-collapse-expand-icon {
        margin: 4px -10px 0px 0px;
       svg {
          fill:#979797;
        }
      }
    } 
  }

  .primary-color{
    color: ${primaryColor};
  }
  .primaryColorGlobal{
    color: ${primaryColor};
  }
  .primary-heading-color {
    color: ${primaryHeadingColor} !important;
  }

  .mobile-scroll-row {
    @media all and (max-width: ${maxMobile}){
      padding: 0 25px;
      overflow-x: scroll;
      flex-flow: unset;
      ${scrollbarTransparent};
      .mobile-scroll-col {
        flex: 0 0 134px !important;
        min-width: 134px !important;
      }
    }
  }

  .sub-primary-nav-follow {
    @media all and (max-width: ${maxMobile}){
      margin-right: auto;
      padding-right: 15px;
    }
  }

  .global-tabs-item {
    .filter-icon-dropdown {
      min-width: 18px;
    }
  }
  .tooltip-account-popover {
    left: -350px !important;
    &.discLessUser {
      display: none;
    }
    &.certificationNewToolTip {
      left: -156px !important;
      @media all and (max-width: ${maxTablet}) {
        left: -185px !important;
      }
      @media all and (max-width: ${maxMobile}) {
        left: -217px !important;
      }
      .ant-tooltip-content {
        width: 246px;
        .ant-tooltip-arrow {
          display: none;
        }
        .ant-tooltip-inner {
          padding: 12px;
          border-radius: 8px;
        }
      }
      &.discLessUser {
        display: none;
      }
    }
    &.mapProfile {
      left: -262px !important;
    }
    &.addCrossIcon {
      .ant-tooltip-content {
        .ant-tooltip-inner {
            padding: 12px 30px 12px 22px;
        }
      }
    }
    .ant-tooltip-arrow {
      right: 16px !important; 
    }
    .ant-tooltip-content {
      width: fit-content;
      .ant-tooltip-inner {
        border-radius: 15px;
        padding: 12px 22px;
        font-family: ${primaryFont};
        font-weight: ${wLight};
        color: #5E7079;
        font-size: 13px;
        line-height: 18px;
        .bold {
          font-weight: ${wMedium};
        }
      }
    }
  }
  .highlightedComponent {
    z-index: 999;
    position: relative;
    &.backgroundColorHighlighted {
      background-color: #fff;
      border-radius: 5px;
    }
    &.subComponentOverlayWhite {
      background-color: #fff;
      padding: 20px;
      border-radius: 5px;
    }
    &.downloadProfileBtn {
      background-color: #fff;
      padding: 8px;
      border-radius: 5px;
    }
    
  }
  .highlightedSubNavBar {
    z-index: 5 !important;
    background-color: #ffffff !important;
    border-radius: 12px;
  }
  .underline-text-toaster-Message {
    text-decoration: underline;
    color: #fff;
    cursor: pointer;
    :active,:hover {
      color: #fff;
    }
  }
  .loading-toaster {
    .ant-spin {
      .ant-spin-dot {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        .ant-spin-dot-item {
          background-color: #fff;
        }
      }
    }
  }
  .triggers-bullet-tooltip {
    &.disabledTooltip {
      .ant-tooltip {
        max-width: 266px;
      }
    }
    &.smartHistoryTip {
      .ant-tooltip-content {
        .ant-tooltip-inner {
          font-size: 12px;
          white-space: pre;
        }
      }
    }
  &.gilroyV2Tooltip {
    .ant-tooltip {
      .ant-tooltip-content {
        .ant-tooltip-inner {
          white-space: break-spaces;
        }
      }
    }
  }
  &.gilroyV3Tooltip {
    .ant-tooltip {
      .ant-tooltip-content {
        .ant-tooltip-arrow {
          width: 20px;
          height: 20px;
        }
        .ant-tooltip-inner {
          padding: 6px 10px;
          min-height: 25px;
          max-height: 54px;
          font-size: 12px;
          line-height: 16px;
          max-width: 200px;
          word-wrap: break-word;
          white-space: break-spaces;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          display: -webkit-box;
        }
      }
    }
  }
    &.person-designation-tip {
      .ant-tooltip {
        .ant-tooltip-content {
          .ant-tooltip-inner {
            max-width: 250px;
            white-space: normal;
          }
        }
      }
    }
    &.gill-roy-tip {
      z-index: 0;
      .ant-tooltip {
        padding-top: 14px !important;
        @media all and (max-width: ${maxWidth}), ${retina} {
          padding-top: 0px !important;
        }
      }
    }
    &.tooltip-with-copy-action {
      .ant-tooltip {
        max-width: 100%;
      }
      .ant-tooltip-content {
        .ant-tooltip-arrow {
          bottom: 1px;
        }
        .ant-tooltip-inner {
          padding: 8px 16px;
          width: fit-content;
          .tooltip-content-div {
            display: flex;
            align-items: center;
            .title {
              white-space: pre;
            }
            .weight-700 {
              margin-left: 5px;
            }
            .copyIcon {
              width: 24px;
              min-width: 24px;
              height: 24px; 
              margin-left: 10px;
              background-color:#fff;
              padding: 2px 4px;
              &:hover {
                background-color: rgba(30, 194, 82, 0.1);
                border-radius: 4px;
                path {
                  fill: ${primaryColor};
                }
              }
            }
          }
        }
      }
    }
    .ant-tooltip-content {
      width: fit-content;
      .ant-tooltip-inner {
        min-width: 45px;
        font-family: ${primaryFont};
        font-weight: ${wMedium};
        padding: 10px;
        color: ${primaryHeadingColor};
        border-radius: 8px;
      }
    }
    &.button-tooltip {
      white-space: nowrap;
      .ant-tooltip{
        top: 40px !important;
      }
    }
    &.no-wrap{
      white-space: nowrap;
    }
  }
  .ask-gillRoy-drawer {
    .close-alerts {
      position: absolute;
      right: 20px;
    }
  }
  /*  .loader-wrap-animated {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 210px);
    z-index: 999;
      @media all and (max-width: ${maxWidth}) , ${retina}{
        height: calc(100vh - 200px);
      }
    img {
      width: 100px;
    }
  } */
  .filter-similar-people-popover {
      @media all and (max-width: ${smMobile}) {
        left: unset !important;
        right: 10px !important;
      }
    .ant-popover-content {
      .ant-popover-inner {
        border-radius: 13px;
        padding: 0px;
      }
    }
  }
  .drawer-upload-document {
    &.sapUploadDrawer {
       .ant-drawer-content-wrapper {
        .ant-drawer-content {
          .ant-drawer-body {
            padding: 26px 39px 0px;
          }  
        }
      }
    }
    z-index: 5;
    .ant-drawer-content-wrapper {
      .ant-drawer-content {
        .ant-drawer-header {
          .ant-drawer-extra {
            display: flex;
            justify-content: flex-end;
          }
        }
        .ant-drawer-body {
          padding: 26px 35px 0px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            padding: 0 24px;
          }
          @media all and (max-width: ${maxTablet}) {
            padding: 0 10px;
          }
          .drawer-heading {
            font-family: ${secondaryFont};
            font-size: 32px;
            font-weight: ${wMBold};
            color: ${primaryHeadingColor};
            line-height: normal;
            letter-spacing: -0.709px;
            margin-bottom: 12px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              font-size: 24px;
              line-height: 28px;
            }
          }
          .upload-btn-div {
            display: flex;
            align-items: center;
            .add-file-btn {
              display: none;
            }
            .add-link-btn {
              display: none;
            }
            svg {
              width: 20px;
              height: 20px;
              @media all and (max-width: ${maxWidth}), ${retina} {
                width: 18px;
                height: 16px;
              }
            }
          }
        }
      }
    }
  }
  .doc-tooltip-layer {
    z-index: 3 !important;
    .ant-tooltip-content {
      width: 300px;
      .ant-tooltip-inner {
        color: unset;
        padding: 6px 8px;
        .tooltip_wrapper {
          padding: 10px;
          display: flex;
          flex-direction: column;
          .tooltip-text-tour {
            display: block;
            font-family: ${primaryFont};
            font-size: 14px;
            line-height: 16px;
            font-weight: ${wLight};
            color: rgb(0, 0, 0);
            white-space: pre-wrap;
          }
        }
      }
    }
  }
  .popover-tagging-gilroy {
    left: 0px !important;
    padding-bottom: 0px;
    &.gilroyV3TaggingPopover {}
    .ant-popover-content {
      .ant-popover-arrow {
        display: none;
      }
      .ant-popover-inner {
        border-radius: 8px;
        background: #FFF;
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.28);
        min-width: 323px;
        padding: 0px;
        .ant-popover-title {
          @media all and (max-width: ${maxTablet}) {
            display: none;
          }
        }
        .ant-popover-inner-content {
          padding: 0px;
          width: 100%;
          height: 100%;
          max-width: 100%;
          min-height: 210px;
        }
      }
    }
  }
  .results-toggle, .not-recommended-result-toggle {
    display: none;
    &.showRecommended {
      display: block;
    }
  }
  .list-data-recommended {
    @media all and (max-width: ${maxMobile}) {
      margin-top: -20px;
    }
  }
  .intent-drawer-wrapper {
    .ant-drawer-extra  {
      width: 100%;
    }
  }
  .share-profile-dropdown {
    z-index: 1;
    inset: auto !important;
    right: 30px !important;
  }
  .share-profile-dropdown .ant-popover-inner{
    border-radius:20px;
    padding:0;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius:10px;
    }
  }

  .articlesWrapperFeed{
    margin-top: 16px;
  }

  .spotLightWrapper2.parentClassToHighPrecedence{
    .heroTilesWrapper{
      height: 100%;
      @media screen and (max-width: ${maxMobile} ){
        height: auto;
      }
      .ant-col{
        padding: 0 8px !important;
      }
    }
    .desktopListViewTilesWrapper{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .articleGridTilesWrapper{
      @media screen and (max-width: ${maxMobile} ){
        margin-bottom: 10px !important;
      } 
      .gridTile{
        height: 100%;
        max-height: 100%;
        width: 100%;
        max-width: 100%; 
        .profile-area{
          min-height: 249px;
          max-height: 249px;
          @media all and (min-width: ${minExtraLargeScreen}) {
            min-height: 428px;
            max-height: 428px;
          }
          @media all and (max-width: ${maxWidth}) , ${retina} {
            min-height: 236px; 
            max-height: 236px;
          }
          @media all and (max-width: ${minStandardScreen}) {
            min-height: 235px; 
            max-height: 235px;
          }
          @media all and (max-width: ${maxTablet}) {
            min-height: 184px; 
            max-height: 184px;
          }
          @media screen and (max-width: ${maxMobile} ){
            min-height: 293px; 
            max-height: 293px;
          }
        }        
        .text-area{
          min-height: 97px;
          @media all and (min-width: ${minExtraLargeScreen}) {
            min-height: 137px;
          }
          @media all and (max-width: ${maxWidth}) , ${retina} {
            min-height: 97px;
          }
          @media all and (max-width: ${minStandardScreen}) {
            min-height: 75px;
          }
          @media all and (max-width: ${maxTablet}) {
            min-height: 59px;
          }
          @media screen and (max-width: ${maxMobile} ){
            min-height: unset;
          }
          &::before {
            @media all and (min-width: ${minExtraLargeScreen}) {
              width: 9px;
            }
            @media all and (max-width: ${minStandardScreen}) {
              width: 6px;
            }
            @media all and (max-width: ${maxTablet}) {
              width: 4px;
            }
            @media all and (max-width: ${maxMobile}) {
              width: 4px;
            }
          }
          .heading{
            @media all and (max-width: ${maxTablet}){
              margin-bottom: 14px;
            }
          }
        }
      }
    }
    .listView{
      &:last-child{
        .tileListView{
          margin-bottom: 0;
        }
      }
      .tileListView{
        @media screen and (min-width: ${minExtraLargeScreen} ){
          height: 187px;
        }
        .profile-area,
        .videoFrameArea{
        @media screen and (min-width: ${minExtraLargeScreen} ){
            width: 155px;
            min-width: 155px;
            height: 159px;
            border-radius: 12px;
          }
        }
        .text-area{
          width: unset;
          min-width: unset;
          padding-right: 0;
          overflow: hidden;
          .heading{
            margin-bottom: 0;
            padding-right: 10px;
            &.text-truncate-one-line{
              -webkit-line-clamp: 3;
            }
          }
          .article_summary {
            display: none;
          }
        }
      }
    }
    .states-widget-primary{
      background: ${white};
      min-height: 123px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 8px;
      @media all and (min-width: ${minExtraLargeScreen}) {
        min-height: 174px;
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        min-height: 90px;
      }
      @media all and (max-width: ${minStandardScreen}) {
        min-height: 80px;
      }
      @media all and (max-width: ${maxTablet}){
        min-height: 72px;
      }
    }
  }

`;

export default generalStylePeople;
